import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import Flux from '../Flux';

const data = {
	toyControls: [],
};

const ChangeEvents = {
	toyControlStoreInitialized: 'toyControlStoreInitialized',
};

const MessengerToyControlStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: ChangeEvents,

	_init: function () {
		Flux.Messenger.getMessengerToyControls(function (response) {
			data.toyControls = response.data.messenger.toyControls;
			MessengerToyControlStore.emit(ChangeEvents.toyControlStoreInitialized);
		});
	},

	getToyControls: function () {
		return data.toyControls;
	},
});

export default MessengerToyControlStore;
